import React from 'react'

import FormElement from '@/Form/toolkit/FormElement'

export default function RegistrationLegal ({ ...props })
{
	const { handleChange, form_data } = props;

	return (
		<div className="registration-cbs">

			<div className="registration-cbs__container">

				<div className="registration-cbs__el">

					<a href="https://www.synergies.site/pdf/politique-rgpd-synergies.pdf"
						target="_blank" rel="noreferrer">
						Lire la politique RGPD
					</a>

					<FormElement type="checkbox" name="user[rgpd]"
						label="J'accepte le RGPD" id_prefix="registration-form-"
						onChange={ handleChange } data={ form_data }
						status={ props.status }
						className="u-margin-top-0 u-positioned"
						required
					/>

				</div>

				<div className="registration-cbs__el">

					<a href="/documents/CGU_v10_10_2019.pdf"
						target="_blank" rel="noreferrer">
						Lire les CGU
					</a>

					<FormElement type="checkbox" name="user[cgu]"
						label="J'accepte les CGU" id_prefix="registration-form-"
						onChange={ handleChange } data={ form_data }
						status={ props.status }
						className="u-margin-top-0 u-positioned"
						required
					/>

				</div>

				<div className="registration-cbs__el">

					<FormElement type="checkbox" name="user[newsletter]"
						label="Recevoir la newsletter Synergies"
						id_prefix="registration-form-"
						onChange={ handleChange } data={ form_data }
						status={ props.status }
						className="u-margin-top-0 u-positioned"
					/>

				</div>

			</div>

		</div>
	);
}